import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorReturnSummaryList = () => {
  const returnSummaryList = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/transaction-retur-header/retur-summary', payload, (response) => {
      if (response.status_code === 200) {
        if (response.data) {
          callback(response.data)
        }
      }
      loading(false)
    })
  }, [])
  return { returnSummaryList }
}

export default InteractorReturnSummaryList
